<template>
  <v-container fluid class="py-0" :style="'height:' + computedPageHeight + 'px'">

    <v-row >
      <v-col
        class="pa-0">

        <!-- on image bar -->
        <v-row class="carousel-top-element white--text">
          <v-col class="py-0 max-width-1200 mx-auto">
            <app-bar-menu
              component="RubinAbout"
              logo="light"
              dark="dark">
            </app-bar-menu>
          </v-col>
        </v-row>

        <!-- hero -->
        <v-card flat dark>
          <v-img
            id="img-main"
            src="@/assets/img/rubin-img-02.jpg"
            class="grey lighten-2"
            cover
            :max-height="computedPageHeight"
            :style="'height:' + computedPageHeight + 'px'">
            <v-row
              class="fill-height overlay mx-0"
              align="center"
              justify="center">
              <v-col class="">
                <v-row class="mx-0">
                  <v-col class="text-center">
                    <span class="mr-4 subsite-title-1" style="line-height:6rem;">{{ $t('rubin.rubin') }}</span>
                    <span class="subsite-title-2" style="line-height:3rem;">{{ $t('rubin.informatic') }}</span>
                  </v-col>
                </v-row>
                <v-row class="mx-0">
                  <v-col class="text-center pa-0 subsite-title-3">
                    {{ $t("rubin.introduction.short") }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <!-- ic img -->
            <v-row class="carousel-bottom-controls">
              <v-col class="pa-0 img-ic-box flip-x">
              </v-col>
            </v-row>

            <!-- landing scroll menu -->
            <v-row class="menu landing-scroll">
              <v-col class="max-width-1200 px-0 mx-auto">
                <v-btn
                  v-for="(item,index) in sections"
                  :key="index"
                  text
                  @click="scrollTOSection(item.id)">
                    {{ $t(item.title) }}
                </v-btn>
                <!-- <a
                  v-for="(item,index) in sections"
                  :key="index"
                  :href="'#' + item.id">
                  <div id="btn1" class="button">
                    <h1>{{ $t(item.title) }}</h1>
                  </div>
                </a> -->
              </v-col>
            </v-row>
          </v-img>
        </v-card>

        <v-row class="mx-1">
          <v-col id="company">
            <Company></Company>
          </v-col>
        </v-row>


        <v-row class="mx-1">
          <v-col id="vision">
            <Vision></Vision>
          </v-col>
        </v-row>

        <v-row class="mx-0 bg-grey-light">
          <v-col id="values">
            <Values></Values>
          </v-col>
        </v-row>

        <v-row class="mx-0 bg-ruby">
          <v-col id="awards">
            <Awards></Awards>
          </v-col>
        </v-row>

        <v-row class="mx-1">
          <v-col id="feedback">
            <Feedback></Feedback>
          </v-col>
        </v-row>

        <v-row class="mx-0 bg-grey-light">
          <v-col id="career">
            <Career></Career>
          </v-col>
        </v-row>

        <v-row class="mx-0 bg-ruby">
          <v-col>
            <Contact></Contact>
          </v-col>
        </v-row>


      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import AppBarMenu from '@/components/Common/AppBar.vue';
  import DataComponentBase from '@/commons/DataComponentBase';

  import Company    from '@/components/RubinAbout/Company.vue'
  import Vision     from '@/components/RubinAbout/Vision.vue'
  import Values     from '@/components/RubinAbout/Values.vue'
  import Awards     from '@/components/RubinAbout/Awards.vue'
  import Feedback   from '@/components/RubinAbout/Feedback.vue'
  import Career     from '@/components/RubinAbout/Career.vue'
  import Contact    from '@/components/Common/Contact.vue'

  export default {
    name: 'RubinAbout',
    metaInfo: {
      title: 'Rólunk',
      titleTemplate: '%s - Rubin Informatika',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Komplex IT-rendszereket szállítunk telekommunikációs, energetikai és gyártó partnereink számára. Ügyfeleink igényeit profi csapatunk egyedi megoldásokkal szolgálja ki a tervezéstől a fejlesztésen át a telepítésig. Energiamenedzsment, és infrastruktúrafelügyeleti megoldásaink magas minősége megkülönböztet minket versenytársainktól.'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'Java, telkeommunikációs, Freecooling, mesterséges intelligencia, energiamenedzsment, Hardverfejlesztés'
        }
      ],
      __dangerouslyDisableSanitizers: ['meta'],
    },

    extends: DataComponentBase,

    components: {
      AppBarMenu,
      Company,
      Vision,
      Values,
      Awards,
      Feedback,
      Career,
      Contact,
    },

    data: () => ({
      sections: [
        { id: "company",  title: "company.company.title", },
        { id: "vision",   title: "company.vision.title", },
        { id: "values",   title: "company.values.title", },
        { id: "awards",   title: "company.awards.title", },
        { id: "feedback", title: "company.feedback.title", },
        { id: "career",   title: "career.title", },
      ],

    }),

    mounted() {
    },

    computed: {
      mini() {
        if (this.computedWidth < 800) {
          return true
        } else {
          return false
        }
      },

    },

    methods: {
      scrollTOSection(id) {
        var section = document.getElementById(id);
        section.scrollIntoView();
      }
    },

    watch: {
      computedWidth() {
      }
    },
  }

</script>

<style src="../Style.css">
</style>
